import { Controller } from '@hotwired/stimulus'
import merge from "lodash/merge"

export default class extends Controller {
  static targets = ["data", "element", "dynamicClass"]

  initialize() {
    this.dynamicData = {}
  }

  // Lifecycle callback: https://stimulus.hotwired.dev/reference/lifecycle-callbacks#methods
  dataTargetConnected(dataElement) {
    merge(this.dynamicData, JSON.parse(dataElement.innerHTML))
  }

  // Lifecycle callback: https://stimulus.hotwired.dev/reference/lifecycle-callbacks#methods
  elementTargetConnected(element) {
    const key = element.dataset.dynamicContentKey
    if (this.dynamicData.hasOwnProperty(key)) {
      const value = this.dynamicData[key]
      element.innerHTML = value
    }
  }

  dynamicClassTargetConnected(element) {
    const key = element.dataset.dynamicClassKey
    if (this.dynamicData.hasOwnProperty(key)) {
      const value = this.dynamicData[key]
      if (value) {
        element.classList.add(value)
      }
    }
  }
}
